export default {
  cursor: {
    links: {
      next: '',
      previous: ''
    }
  }
}


// WEBPACK FOOTER //
// ./resources/assets/js/app/store/models/cursor.js